import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))

export const ChangelogRouter = React.memo(() => (
  <SubRouter loggedIn>
    <Route path='*' element={<Index />} />
  </SubRouter>
))
